import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui";

interface RelationTypeActivationDialogProps {
  open: boolean;
  action: "activate" | "deactivate";
  name: string;
  processing: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirm prompt for activate / deactivate. Names the relation type being acted
 * on (V1 used the same `deactivateX` / `activateX` copy).
 */
export function RelationTypeActivationDialog({
  open,
  action,
  name,
  processing,
  onConfirm,
  onCancel,
}: RelationTypeActivationDialogProps) {
  const { t } = useTranslation();
  const isDeactivate = action === "deactivate";

  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("feature.common.confirmTitle")}</AlertDialogTitle>
          <AlertDialogDescription>
            {isDeactivate ? t("ui.deactivateX", { x: name }) : t("ui.activateX", { x: name })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={processing}>{t("ui.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={processing}>
            {isDeactivate ? t("ui.deactivate") : t("ui.activate")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
